(function(W) {
    "use strict";

    function App() {
        var store = {};
        var repository = function(name, cb) {
            if (!(name in store)) {
                store[name] = (function (fn) {
                    fn.call(store[name], store[name]);
                });
                // APP.<name>
                Object.defineProperty(repository, name, {
                    value: store[name]
                });
            }
            if (cb) {
                store[name](cb);
            }
            return store[name];
        };
        return repository;
    }

    W.APP = new App();

    /**
     * @typedef {Object} APP.edge_replace
     */
    APP('edge_replace', function () {
        this.on = function () {
            if (/Edge/.test(navigator.userAgent)) {
                $('picture').each(function () {
                    $(this).after(($(this).find('img')));
                    $(this).remove();
                });
            }
        }
    });

    /**
     * @typedef {Object} APP.core
     * @property {function(function):Promise} promise
     * @property {function(function,number=100):function} debounce
     */
    APP('core', function() {
        this.promise = function(fn) {
            var dfd = $.Deferred();
            fn.call(this, dfd.resolve, dfd.reject);
            return dfd.promise();
        };
        // this.once = function(fn) { };
        this.debounce = function (fn, threshold) {
            var timeout;
            return function () {
                var obj = this, args = arguments;
                function delayed() {
                    fn.apply(obj, args);
                    timeout = null;
                }
                if (timeout) {
                    clearTimeout(timeout);
                }
                timeout = setTimeout(delayed, threshold || 100);
            };
        };
    });

    /**
     * @typedef {Object} APP.events
     * @property {function(string, function):void} on
     * @property {function(string, object=null):void} fire
     */
    APP('events', function() {
        var store = {};
        this.on = function (es, cb) {
            if (typeof cb !== 'function') {
                return;
            }
            if (!Array.isArray(es)) {
                es = es.trim().split(/\s+/);
            }
            for (var i = 0; i < es.length; i++) {
                var e = es[i];
                if (!store.hasOwnProperty(e)) {
                    store[e] = [];
                }
                store[e].push(cb);
            }
        };
        this.fire = function (e, args) {
            if (!store.hasOwnProperty(e)) {
                return;
            }
            args = args || [];
            for (var i = 0; i < store[e].length; i++) {
                store[e][i].apply({}, args)
            }
        };
    });

})(window);